import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faLinkedin, faPinterest, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';
import BrandButton from './brand-button';
import ContactAddress from './contact/contact-address-text';
import ContactEmail from './contact/contact-email';
import ContactPhone from './contact/contact-phone';

const FooterComp = () => {
    const { t, i18n } = useTranslation();
    const contactUsLbl = i18n.exists("forms.contactUs") ? t('forms.contactUs') : "Връзка с нас"; 
    return (
        <div className="bl-footer">
            <footer id="footer" className="text-center text-lg-left">
                <div className="container">
                    <div className="row">
                    <div className="col-6 col-xs-6 col-lg-3">
                        <figure>
                        <a href="/">
                            <img
                            className="img-responsive"
                            src={`${process.env.PUBLIC_URL}/img/logo-text.svg`}
                            alt="Kate International"
                            />
                        </a>
                        </figure>
                        <div className="footer-text">
                            <div>
                                <a className='inter-thin' href="http://www.google.com/maps/place//data=!4m2!3m1!1s0x40aa84fdaeddd219:0x7237ba28dbdc492d?sa=X&ved=1t:8290&ictx=111">
                                    <ContactAddress textAlign="left" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-xs-6 col-lg-2">
                        <BrandButton text='Make an appointment' href='/appointment' title='Make an appointment' />
                    </div>
                    <div className="col-6 col-xs-6 col-lg-3 offset-lg-1">
                        <div className="footer-text">
                            <div>
                                <a className='inter-thin' href="tel:+359886010515"><ContactPhone /></a>
                                <br />
                                <a className='inter-thin' href="mailto:office@kateinternational.eu">
                                   <ContactEmail />
                                </a>
                            </div>{" "}
                            <div className="col-12 p-0">
                                <div className="social-box">
                                <a
                                    href="https://www.youtube.com/@kateinternational9917"
                                    title="KateInternation in YouTube"
                                    target="_blank"
                                    rel="noreferrer" 
                                >
                                    <FontAwesomeIcon icon={faYoutube} />
                                </a>
                                <a
                                    href="https://www.instagram.com/kate.international/"
                                    title="KateInternational in Instagram"
                                    target="_blank"
                                    rel="noreferrer" 
                                >
                                    <FontAwesomeIcon icon={faInstagram} />
                                </a>
                                <a
                                    href="https://www.linkedin.com/company/kate-int/"
                                    title="Kate International in LinkedIn"
                                    target="_blank"
                                    rel="noreferrer" 
                                >
                                    <FontAwesomeIcon icon={faLinkedin} />
                                </a>
                                <a
                                    href="https://www.facebook.com/kateint"
                                    title="Kate International in FaceBook"
                                    target="_blank"
                                    rel="noreferrer" 
                                >
                                    <FontAwesomeIcon icon={faFacebookF} />
                                </a>
                                <a
                                    href="https://www.pinterest.com/kateinternation/?invite_code=f71e400e130f4d4fbfcafd2cb502c43c&sender=687362099285856713"
                                    title="Kate International in Pinterest"
                                    target="_blank"
                                    rel="noreferrer" 
                                >
                                    <FontAwesomeIcon icon={faPinterest} />
                                </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-xs-6 col-lg-3 p-0">
                        <div className="row align-items-center">
                            <div className="col-12 col-lg-12">
                                <BrandButton text={t('pages.subscribe')} href='https://kateinternational.eu/subscribe' title={t('pages.subscribe')} />
                            </div>
                            <div className="col-12 col-lg-12">
                                <BrandButton text={contactUsLbl} href='/contact' title={contactUsLbl} />
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className='footer-border'></div>
            </footer>
        </div>
    )
}

export default FooterComp;